<template>
    <div
        class="h-1 flex-1 overflow-hidden rounded bg-theme-progress-track"
        :class="{ 'cursor-pointer': isSeekable }"
        :role="isSeekable ? 'slider' : 'progressbar'"
        :aria-valuenow="Math.round(percent)"
        aria-valuemin="0"
        aria-valuemax="100"
        aria-label="Audio progress"
        @click="handleClick"
    >
        <div
            class="h-full rounded transition-[width] duration-300"
            :class="progressFillClass"
            :style="progressFillStyle"
        />
    </div>
</template>

<script>
/**
 * Progress bar for TTS players.
 * Supports two modes:
 * - Seekable (Amazon Polly): Shows actual progress, clickable to seek
 * - Visual-only (Web Speech): Shows animated indicator when playing
 */
export default {
    name: 'TtsProgressBar',
    props: {
        percent: {
            type: Number,
            default: 0,
        },
        isPlaying: {
            type: Boolean,
            default: false,
        },
        isSeekable: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['seek'],
    computed: {
        progressFillClass() {
            if (this.isSeekable) {
                return 'bg-theme-title';
            }
            return this.isPlaying ? 'w-3/5 bg-theme-title' : 'w-0';
        },
        progressFillStyle() {
            return this.isSeekable ? { width: `${this.percent}%` } : null;
        },
    },
    methods: {
        /**
         * Handles click on progress bar for seek functionality.
         * @param {MouseEvent} event - Click event
         */
        handleClick(event) {
            if (!this.isSeekable) return;
            const progressBarRect = event.currentTarget.getBoundingClientRect();
            const clickPercent = (event.clientX - progressBarRect.left) / progressBarRect.width;
            this.$emit('seek', clickPercent);
        },
    },
};
</script>
